module.exports = __webpack_public_path__ + "static/brand10-406ed1ff96f9912a67bfda50c6722f0f.png";